window.bzSubmitAjaxLogin = (f, url, lyr_id, func) => {
	if(!bzLoginValidate(f)) { return false; }

	url = url + '?' + bzNoCache();
	bzAjaxRequest(url, lyr_id, f.id, func);
}

window.bzSubmitLogin = (f) => {
	if(!bzLoginValidate(f)) { return false; }
	f.submit();
}

window.bzLoginValidate = (f) => {
	if(f.username.value==='') {
		alert('Please fill in your username.');
		f.login_btn.value='Submit';
		return false;
	}

	if(f.password.value==='') {
		alert('Please fill in your password.');
		f.login_btn.value='Submit';
		return false;
	}

	return true;
}

window.bzLoginRedirect = (fuid) => {
	let obj = document.getElementById('lyr_login_redir'+fuid);
	if(!obj) { return; }

    let pg = obj.innerHTML;

	if(pg) { location.href = pg; }

	else { alert('JS Error: No page to redirect to.'); }
}
